function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var jsep = createCommonjsModule(function (module, exports) {
(function (root) {
	var COMPOUND = 'Compound',
		IDENTIFIER = 'Identifier',
		MEMBER_EXP = 'MemberExpression',
		LITERAL = 'Literal',
		THIS_EXP = 'ThisExpression',
		CALL_EXP = 'CallExpression',
		UNARY_EXP = 'UnaryExpression',
		BINARY_EXP = 'BinaryExpression',
		LOGICAL_EXP = 'LogicalExpression',
		CONDITIONAL_EXP = 'ConditionalExpression',
		ARRAY_EXP = 'ArrayExpression',
		PERIOD_CODE = 46,
		COMMA_CODE  = 44,
		SQUOTE_CODE = 39,
		DQUOTE_CODE = 34,
		OPAREN_CODE = 40,
		CPAREN_CODE = 41,
		OBRACK_CODE = 91,
		CBRACK_CODE = 93,
		QUMARK_CODE = 63,
		SEMCOL_CODE = 59,
		COLON_CODE  = 58,
		throwError = function(message, index) {
			var error = new Error(message + ' at character ' + index);
			error.index = index;
			error.description = message;
			throw error;
		},
		t = true,
		unary_ops = {'-': t, '!': t, '~': t, '+': t},
		binary_ops = {
			'||': 1, '&&': 2, '|': 3,  '^': 4,  '&': 5,
			'==': 6, '!=': 6, '===': 6, '!==': 6,
			'<': 7,  '>': 7,  '<=': 7,  '>=': 7,
			'<<':8,  '>>': 8, '>>>': 8,
			'+': 9, '-': 9,
			'*': 10, '/': 10, '%': 10
		},
		getMaxKeyLen = function(obj) {
			var max_len = 0, len;
			for(var key in obj) {
				if((len = key.length) > max_len && obj.hasOwnProperty(key)) {
					max_len = len;
				}
			}
			return max_len;
		},
		max_unop_len = getMaxKeyLen(unary_ops),
		max_binop_len = getMaxKeyLen(binary_ops),
		literals = {
			'true': true,
			'false': false,
			'null': null
		},
		this_str = 'this',
		binaryPrecedence = function(op_val) {
			return binary_ops[op_val] || 0;
		},
		createBinaryExpression = function (operator, left, right) {
			var type = (operator === '||' || operator === '&&') ? LOGICAL_EXP : BINARY_EXP;
			return {
				type: type,
				operator: operator,
				left: left,
				right: right
			};
		},
		isDecimalDigit = function(ch) {
			return (ch >= 48 && ch <= 57);
		},
		isIdentifierStart = function(ch) {
			return (ch === 36) || (ch === 95) ||
					(ch >= 65 && ch <= 90) ||
					(ch >= 97 && ch <= 122) ||
                    (ch >= 128 && !binary_ops[String.fromCharCode(ch)]);
		},
		isIdentifierPart = function(ch) {
			return (ch === 36) || (ch === 95) ||
					(ch >= 65 && ch <= 90) ||
					(ch >= 97 && ch <= 122) ||
					(ch >= 48 && ch <= 57) ||
                    (ch >= 128 && !binary_ops[String.fromCharCode(ch)]);
		},
		jsep = function(expr) {
			var index = 0,
				charAtFunc = expr.charAt,
				charCodeAtFunc = expr.charCodeAt,
				exprI = function(i) { return charAtFunc.call(expr, i); },
				exprICode = function(i) { return charCodeAtFunc.call(expr, i); },
				length = expr.length,
				gobbleSpaces = function() {
					var ch = exprICode(index);
					while(ch === 32 || ch === 9 || ch === 10 || ch === 13) {
						ch = exprICode(++index);
					}
				},
				gobbleExpression = function() {
					var test = gobbleBinaryExpression(),
						consequent, alternate;
					gobbleSpaces();
					if(exprICode(index) === QUMARK_CODE) {
						index++;
						consequent = gobbleExpression();
						if(!consequent) {
							throwError('Expected expression', index);
						}
						gobbleSpaces();
						if(exprICode(index) === COLON_CODE) {
							index++;
							alternate = gobbleExpression();
							if(!alternate) {
								throwError('Expected expression', index);
							}
							return {
								type: CONDITIONAL_EXP,
								test: test,
								consequent: consequent,
								alternate: alternate
							};
						} else {
							throwError('Expected :', index);
						}
					} else {
						return test;
					}
				},
				gobbleBinaryOp = function() {
					gobbleSpaces();
					var to_check = expr.substr(index, max_binop_len), tc_len = to_check.length;
					while(tc_len > 0) {
						if(binary_ops.hasOwnProperty(to_check) && (
							!isIdentifierStart(exprICode(index)) ||
							(index+to_check.length< expr.length && !isIdentifierPart(exprICode(index+to_check.length)))
						)) {
							index += tc_len;
							return to_check;
						}
						to_check = to_check.substr(0, --tc_len);
					}
					return false;
				},
				gobbleBinaryExpression = function() {
					var node, biop, prec, stack, biop_info, left, right, i, cur_biop;
					left = gobbleToken();
					biop = gobbleBinaryOp();
					if(!biop) {
						return left;
					}
					biop_info = { value: biop, prec: binaryPrecedence(biop)};
					right = gobbleToken();
					if(!right) {
						throwError("Expected expression after " + biop, index);
					}
					stack = [left, biop_info, right];
					while((biop = gobbleBinaryOp())) {
						prec = binaryPrecedence(biop);
						if(prec === 0) {
							break;
						}
						biop_info = { value: biop, prec: prec };
						cur_biop = biop;
						while ((stack.length > 2) && (prec <= stack[stack.length - 2].prec)) {
							right = stack.pop();
							biop = stack.pop().value;
							left = stack.pop();
							node = createBinaryExpression(biop, left, right);
							stack.push(node);
						}
						node = gobbleToken();
						if(!node) {
							throwError("Expected expression after " + cur_biop, index);
						}
						stack.push(biop_info, node);
					}
					i = stack.length - 1;
					node = stack[i];
					while(i > 1) {
						node = createBinaryExpression(stack[i - 1].value, stack[i - 2], node);
						i -= 2;
					}
					return node;
				},
				gobbleToken = function() {
					var ch, to_check, tc_len;
					gobbleSpaces();
					ch = exprICode(index);
					if(isDecimalDigit(ch) || ch === PERIOD_CODE) {
						return gobbleNumericLiteral();
					} else if(ch === SQUOTE_CODE || ch === DQUOTE_CODE) {
						return gobbleStringLiteral();
					} else if (ch === OBRACK_CODE) {
						return gobbleArray();
					} else {
						to_check = expr.substr(index, max_unop_len);
						tc_len = to_check.length;
						while(tc_len > 0) {
							if(unary_ops.hasOwnProperty(to_check) && (
								!isIdentifierStart(exprICode(index)) ||
								(index+to_check.length < expr.length && !isIdentifierPart(exprICode(index+to_check.length)))
							)) {
								index += tc_len;
								return {
									type: UNARY_EXP,
									operator: to_check,
									argument: gobbleToken(),
									prefix: true
								};
							}
							to_check = to_check.substr(0, --tc_len);
						}
						if (isIdentifierStart(ch) || ch === OPAREN_CODE) {
							return gobbleVariable();
						}
					}
					return false;
				},
				gobbleNumericLiteral = function() {
					var number = '', ch, chCode;
					while(isDecimalDigit(exprICode(index))) {
						number += exprI(index++);
					}
					if(exprICode(index) === PERIOD_CODE) {
						number += exprI(index++);
						while(isDecimalDigit(exprICode(index))) {
							number += exprI(index++);
						}
					}
					ch = exprI(index);
					if(ch === 'e' || ch === 'E') {
						number += exprI(index++);
						ch = exprI(index);
						if(ch === '+' || ch === '-') {
							number += exprI(index++);
						}
						while(isDecimalDigit(exprICode(index))) {
							number += exprI(index++);
						}
						if(!isDecimalDigit(exprICode(index-1)) ) {
							throwError('Expected exponent (' + number + exprI(index) + ')', index);
						}
					}
					chCode = exprICode(index);
					if(isIdentifierStart(chCode)) {
						throwError('Variable names cannot start with a number (' +
									number + exprI(index) + ')', index);
					} else if(chCode === PERIOD_CODE) {
						throwError('Unexpected period', index);
					}
					return {
						type: LITERAL,
						value: parseFloat(number),
						raw: number
					};
				},
				gobbleStringLiteral = function() {
					var str = '', quote = exprI(index++), closed = false, ch;
					while(index < length) {
						ch = exprI(index++);
						if(ch === quote) {
							closed = true;
							break;
						} else if(ch === '\\') {
							ch = exprI(index++);
							switch(ch) {
								case 'n': str += '\n'; break;
								case 'r': str += '\r'; break;
								case 't': str += '\t'; break;
								case 'b': str += '\b'; break;
								case 'f': str += '\f'; break;
								case 'v': str += '\x0B'; break;
								default : str += ch;
							}
						} else {
							str += ch;
						}
					}
					if(!closed) {
						throwError('Unclosed quote after "'+str+'"', index);
					}
					return {
						type: LITERAL,
						value: str,
						raw: quote + str + quote
					};
				},
				gobbleIdentifier = function() {
					var ch = exprICode(index), start = index, identifier;
					if(isIdentifierStart(ch)) {
						index++;
					} else {
						throwError('Unexpected ' + exprI(index), index);
					}
					while(index < length) {
						ch = exprICode(index);
						if(isIdentifierPart(ch)) {
							index++;
						} else {
							break;
						}
					}
					identifier = expr.slice(start, index);
					if(literals.hasOwnProperty(identifier)) {
						return {
							type: LITERAL,
							value: literals[identifier],
							raw: identifier
						};
					} else if(identifier === this_str) {
						return { type: THIS_EXP };
					} else {
						return {
							type: IDENTIFIER,
							name: identifier
						};
					}
				},
				gobbleArguments = function(termination) {
					var ch_i, args = [], node, closed = false;
					var separator_count = 0;
					while(index < length) {
						gobbleSpaces();
						ch_i = exprICode(index);
						if(ch_i === termination) {
							closed = true;
							index++;
							if(termination === CPAREN_CODE && separator_count && separator_count >= args.length){
								throwError('Unexpected token ' + String.fromCharCode(termination), index);
							}
							break;
						} else if (ch_i === COMMA_CODE) {
							index++;
							separator_count++;
							if(separator_count !== args.length) {
								if(termination === CPAREN_CODE) {
									throwError('Unexpected token ,', index);
								}
								else if(termination === CBRACK_CODE) {
									for(var arg = args.length; arg< separator_count; arg++) {
										args.push(null);
									}
								}
							}
						} else {
							node = gobbleExpression();
							if(!node || node.type === COMPOUND) {
								throwError('Expected comma', index);
							}
							args.push(node);
						}
					}
					if (!closed) {
						throwError('Expected ' + String.fromCharCode(termination), index);
					}
					return args;
				},
				gobbleVariable = function() {
					var ch_i, node;
					ch_i = exprICode(index);
					if(ch_i === OPAREN_CODE) {
						node = gobbleGroup();
					} else {
						node = gobbleIdentifier();
					}
					gobbleSpaces();
					ch_i = exprICode(index);
					while(ch_i === PERIOD_CODE || ch_i === OBRACK_CODE || ch_i === OPAREN_CODE) {
						index++;
						if(ch_i === PERIOD_CODE) {
							gobbleSpaces();
							node = {
								type: MEMBER_EXP,
								computed: false,
								object: node,
								property: gobbleIdentifier()
							};
						} else if(ch_i === OBRACK_CODE) {
							node = {
								type: MEMBER_EXP,
								computed: true,
								object: node,
								property: gobbleExpression()
							};
							gobbleSpaces();
							ch_i = exprICode(index);
							if(ch_i !== CBRACK_CODE) {
								throwError('Unclosed [', index);
							}
							index++;
						} else if(ch_i === OPAREN_CODE) {
							node = {
								type: CALL_EXP,
								'arguments': gobbleArguments(CPAREN_CODE),
								callee: node
							};
						}
						gobbleSpaces();
						ch_i = exprICode(index);
					}
					return node;
				},
				gobbleGroup = function() {
					index++;
					var node = gobbleExpression();
					gobbleSpaces();
					if(exprICode(index) === CPAREN_CODE) {
						index++;
						return node;
					} else {
						throwError('Unclosed (', index);
					}
				},
				gobbleArray = function() {
					index++;
					return {
						type: ARRAY_EXP,
						elements: gobbleArguments(CBRACK_CODE)
					};
				},
				nodes = [], ch_i, node;
			while(index < length) {
				ch_i = exprICode(index);
				if(ch_i === SEMCOL_CODE || ch_i === COMMA_CODE) {
					index++;
				} else {
					if((node = gobbleExpression())) {
						nodes.push(node);
					} else if(index < length) {
						throwError('Unexpected "' + exprI(index) + '"', index);
					}
				}
			}
			if(nodes.length === 1) {
				return nodes[0];
			} else {
				return {
					type: COMPOUND,
					body: nodes
				};
			}
		};
	jsep.version = '0.3.5';
	jsep.toString = function() { return 'JavaScript Expression Parser (JSEP) v' + jsep.version; };
	jsep.addUnaryOp = function(op_name) {
		max_unop_len = Math.max(op_name.length, max_unop_len);
		unary_ops[op_name] = t; return this;
	};
	jsep.addBinaryOp = function(op_name, precedence) {
		max_binop_len = Math.max(op_name.length, max_binop_len);
		binary_ops[op_name] = precedence;
		return this;
	};
	jsep.addLiteral = function(literal_name, literal_value) {
		literals[literal_name] = literal_value;
		return this;
	};
	jsep.removeUnaryOp = function(op_name) {
		delete unary_ops[op_name];
		if(op_name.length === max_unop_len) {
			max_unop_len = getMaxKeyLen(unary_ops);
		}
		return this;
	};
	jsep.removeAllUnaryOps = function() {
		unary_ops = {};
		max_unop_len = 0;
		return this;
	};
	jsep.removeBinaryOp = function(op_name) {
		delete binary_ops[op_name];
		if(op_name.length === max_binop_len) {
			max_binop_len = getMaxKeyLen(binary_ops);
		}
		return this;
	};
	jsep.removeAllBinaryOps = function() {
		binary_ops = {};
		max_binop_len = 0;
		return this;
	};
	jsep.removeLiteral = function(literal_name) {
		delete literals[literal_name];
		return this;
	};
	jsep.removeAllLiterals = function() {
		literals = {};
		return this;
	};
	{
		if (module.exports) {
			exports = module.exports = jsep;
		} else {
			exports.parse = jsep;
		}
	}
}());
});
jsep.parse;

var u={"||":function(r,e){return r||e},"&&":function(r,e){return r&&e},"|":function(r,e){return r|e},"^":function(r,e){return r^e},"&":function(r,e){return r&e},"==":function(r,e){return r==e},"!=":function(r,e){return r!=e},"===":function(r,e){return r===e},"!==":function(r,e){return r!==e},"<":function(r,e){return r<e},">":function(r,e){return r>e},"<=":function(r,e){return r<=e},">=":function(r,e){return r>=e},"<<":function(r,e){return r<<e},">>":function(r,e){return r>>e},">>>":function(r,e){return r>>>e},"+":function(r,e){return r+e},"-":function(r,e){return r-e},"*":function(r,e){return r*e},"/":function(r,e){return r/e},"%":function(r,e){return r%e}},i={"-":function(r){return -r},"+":function(r){return +r},"~":function(r){return ~r},"!":function(r){return !r}};function s(r,e){return r.map(function(r){return a(r,e)})}function c(r,e){var n,t=a(r.object,e);if(n=r.computed?a(r.property,e):r.property.name,/^__proto__|prototype|constructor$/.test(n))throw Error('Access to member "'+n+'" disallowed.');return [t,t[n]]}function a(r,e){var n=r;switch(n.type){case"ArrayExpression":return s(n.elements,e);case"BinaryExpression":return u[n.operator](a(n.left,e),a(n.right,e));case"CallExpression":var t,o,l;if("MemberExpression"===n.callee.type?(t=(l=c(n.callee,e))[0],o=l[1]):o=a(n.callee,e),"function"!=typeof o)return;return o.apply(t,s(n.arguments,e));case"ConditionalExpression":return a(n.test,e)?a(n.consequent,e):a(n.alternate,e);case"Identifier":return e[n.name];case"Literal":return n.value;case"LogicalExpression":return "||"===n.operator?a(n.left,e)||a(n.right,e):"&&"===n.operator?a(n.left,e)&&a(n.right,e):u[n.operator](a(n.left,e),a(n.right,e));case"MemberExpression":return c(n,e)[1];case"ThisExpression":return e;case"UnaryExpression":return i[n.operator](a(n.argument,e));default:return}}

const maxDate = new Date(8640000000000000);
const minDate = new Date(-8640000000000000);
const filterCampaigns = ({ campaigns, userData }) => {
  campaigns = campaigns.filter(campaign => {
    if (campaign.userTargeting && campaign.userTargeting.length > 0) {
      const invalid = campaign.userTargeting.some(rule => {
        const ast = jsep(rule.conditions);
        if (a(ast, userData)) return false;
        else {
          console.log(
            `Campaign ${campaign.name} was refused because the ${rule.name} rule is failling`
          );
          return true;
        }
      });
      return !invalid;
    } else return true;
  });
  return campaigns;
};
const filterByDate = (campaigns, serverTime = new Date()) => {
  campaigns = campaigns.filter(campaign => {
    const startDate = campaign.startDate
      ? new Date(campaign.startDate)
      : minDate;
    const endDate = campaign.endDate ? new Date(campaign.endDate) : maxDate;
    return serverTime >= startDate && serverTime <= endDate;
  });
  return campaigns;
};

class XPROMError extends Error {
  constructor(code, message, parentError) {
    super(message);
    this.code = code;
    this.parentError = parentError;
    this.thisFileName = this.fileName;
    this.thisLineNumber = this.lineNumber;
    this.thisColumnNumber = this.columnNumber;
  }
  toString() {
    try {
      const code = this.code || 'No error code';
      const msg = this.message || 'No error message';
      const file = this.thisFileName;
      const line = this.thisLineNumber;
      const column = this.thisColumnNumber;
      const detailParts = [
        file ? `file: ${file}` : null,
        line ? `line: ${line}` : null,
        column ? `column: ${column}` : null,
      ].filter(e => !!e);
      const details = detailParts.length
        ? ` [[${detailParts.join(' ')}]]]`
        : '';
      let parentString = null;
      if (this.parentError) {
        parentString =
          typeof this.parentError.toString === 'function'
            ? this.parentError.toString()
            : 'Parent error does not have a toString function';
      }
      let stackString = null;
      if (this.stack) {
        stackString =
          typeof this.stack.toString === 'function'
            ? this.stack.toString()
            : 'Stack does not have a toString function';
      }
      const parentPart = parentString
        ? `with parent error:\n${parentString}`
        : `with stack:\n${stackString ? stackString : 'No stack available'}`;
      return `XPromError: [${code}] ${msg}${details} ${parentPart}`;
    } catch (error) {
      return `Failed to execute toString on error due to error: ${error}`;
    }
  }
  get fileName() {
    return this.parentError
      ? this.parentError.fileName
      : this.thisFileName || 'unknown';
  }
  get lineNumber() {
    return this.parentError
      ? this.parentError.lineNumber
      : this.thisLineNumber || 'n/a';
  }
  get columnNumber() {
    return this.parentError
      ? this.parentError.columnNumber
      : this.thisColumnNumber || 'n/a';
  }
}

const ERROR_CODE = {
  UNKNOWN: 'Unknown',
  INITIALIZE: 'Initialize',
};

class XPROMUnknownError extends XPROMError {
  constructor(message, parentError) {
    super(ERROR_CODE.UNKNOWN, message, parentError);
  }
}

class XPROMInitializeError extends XPROMError {
  constructor(message, parentError) {
    super(ERROR_CODE.INITIALIZE, message, parentError);
  }
}

const storage = {
  gameId: null,
  playerId: null,
  switchFunc: null,
  trackingFunc: null,
  payload: {},
  userData: {},
};
function getParamType(key) {
  switch (key) {
    case 'gameId':
      return 'string';
    case 'switchFunc':
      return 'function';
    case 'trackingFunc':
      return 'function';
    case 'payload':
      return 'object';
    case 'playerId':
      return 'string';
    case 'userData':
      return 'object';
    default:
      throw new XPROMUnknownError(`${key} parameter is not implemented`);
  }
}
function getParam(key) {
  if (!storage[key]) throw new XPROMInitializeError(`${key} missing.`);
  return storage[key];
}
function setParam(key, value) {
  const type = getParamType(key);
  if (typeof value !== type)
    throw new XPROMInitializeError(`${key} should be ${type}`);
  storage[key] = value;
}

const getUniqId = () => +new Date();

let prefix = '';
const changePrefix = environment =>
  (prefix = environment === 'production' ? '' : `${environment}-`);
const _changeEnvironment = environment => {
  changePrefix(environment);
};
const fetchAndFilterXPromo = (userData, serverTime) => {
  const gameId = getParam('gameId');
  return fetch(
      `https://x-promo.softgames.com/${prefix}gameConfigs/${gameId}.json?uid=${getUniqId()}`
    )
    .then(res => {
      return res.json();
    }).then(data => {
      const campaigns = filterByDate(data, serverTime);
      if (userData) {
        return filterCampaigns({
          campaigns,
          userData,
        });
      } else return campaigns;
    })
    .catch(() => []);
};

let _campaigns = [];
function getXPromo({ userData, serverTime }) {
  const playerInfo = userData || getParam('userData');
  const now = serverTime || new Date();
  const campaigns = fetchAndFilterXPromo(playerInfo, now);
  _campaigns = campaigns;
  return campaigns;
}
function _getCampaigns() {
  return _campaigns;
}

async function switchGame(campaignId) {
  const campaigns = await _getCampaigns();
  const campaign = campaigns.find(camp => camp.id === parseInt(campaignId, 10));
  if (!campaign)
    throw new XPROMUnknownError(
      `Campaign not found with the id: ${campaignId}`
    );
  const payload = {
    originGameId: getParam('gameId'),
    originPlayerId: getParam('playerId'),
    placement: campaign.placeholder,
    promoReward: campaign.rewardable,
    ...campaign.extraPayload,
  };
  const switchFunc = getParam('switchFunc');
  return switchFunc({ targetGameId: campaign.targetedApp.id, payload });
}

const initialPreparePayload = eventId => ({
  promoReward: reward,
  originGameId: source,
  placement,
}) => ({ eventName: eventId, params: { reward, source, placement } });
var _config = {
  initial: [
    {
      eventId: 'XPromo_NPM_entry',
      get preparePayload() {
        return initialPreparePayload(this.eventId);
      },
      method: 'trackingFunc',
    },
    {
      eventId: 'XPromo_NPM_old_user',
      get preparePayload() {
        return initialPreparePayload(this.eventId);
      },
      condition: ({ playerInfo: { userLifetime } }) => userLifetime > 1,
      method: 'trackingFunc',
    },
    {
      eventId: 'XPromo_NPM_new_user',
      get preparePayload() {
        return initialPreparePayload(this.eventId);
      },
      condition: ({ playerInfo: { userLifetime } }) => userLifetime <= 1,
      method: 'trackingFunc',
    },
  ],
};

const processAction = ({ config, action, payload }) => {
  const events = config[action];
  events.forEach(event => {
    const {
      eventId,
      preparePayload = _payload => _payload,
      condition = () => true,
      method,
    } = event;
    if (!method) throw Error('method property is required in events');
    if (!payload[method])
      throw Error(`payload expect property of ${method} as function`);
    if (condition(payload)) {
      const payloadToMethod = preparePayload(payload);
      payload[method](payloadToMethod);
    }
  });
};
const handler = action => payload =>
  processAction({ action, payload, config: _config });

function initialize({
  gameId,
  playerId,
  switchFunc,
  trackingFunc,
  payload,
  userData,
}) {
  if (gameId) setParam('gameId', gameId);
  if (playerId) setParam('playerId', playerId);
  if (switchFunc) setParam('switchFunc', switchFunc);
  if (trackingFunc) setParam('trackingFunc', trackingFunc);
  if (payload) setParam('payload', payload);
  if (userData) setParam('userData', userData);
  if (payload && payload.originGameId)
    handler('initial')({
      ...payload,
      playerInfo: userData,
      trackingFunc,
    });
}

export { _changeEnvironment, getXPromo, initialize, switchGame };
